// Catch affiliate /discount/XXX links that accidentally get redirected to the myshopify domain:
// After being redirected, they have a couple of specific url params that we can test for.
// (The discount code will be remembered by Shopify, so we just need toreturn the user to the yotoplay domain)
if (~location.host.indexOf('.myshopify.com') && ~location.search.indexOf('rfsn=') && ~location.search.indexOf('=affiliate')){
  location.href = 'https://eu.yotoplay.com' 
}


$(function() {

	var header = $('.site-header');

	function body_lock_toggle() {

		$('body').toggleClass('lock');

	}

	$.fn.extend({
		toggleText: function (a, b) {
			return this.text(this.text() == b ? a : b);
		}
	});

	$.fn.extend({
		toggleHTML: function (a, b) {
			return this.html(this.html() == b ? a : b);
		}
	});

	$('.j-testimonial-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: true,
		variableWidth: true,
		centerMode: true,
		responsive: [
			{
				breakpoint: 639,
				settings: {
					variableWidth: false,
					centerMode: false
				}
			}
		]
	});

	$(window).scroll(function () {

		if ( document.location.href.indexOf('/cart') == -1 ) {
			var innerHeight = window.innerHeight;
			$('.cart-popup').height(innerHeight);
		}

	});

	$(window).scroll(function () {
		if ($(document).scrollTop() > 100) {
			header.addClass('active');
		}
		else {
			header.removeClass('active');
		}
	});

	if ($(window).width() < 1024) {

		$(document).on('click', '.m-accordion', function () {

			console.log('triggered');
			$(this).toggleClass('active');

		});

		//$('.site-header .main-menu').append('<li><a href="/pages/contact/" class="appended">Support</a></li>')
		//$('.site-header .main-menu').append('<li><a href="https://api.yotoplay.com/user/login?redirectUrl=https%3A%2F%2Fuk.yotoplay.com%2Faccount" class="appended j-logged-in">My Account</a></li><li><a href="https://api.yotoplay.com/user/login?redirectUrl=https%3A%2F%2Fuk.yotoplay.com%2Faccount" class="appended j-not-logged-in">Login / Register</a></li><li><a href="/pages/contact/" class="appended">Support</a></li>')

		$('.j-pq-carousel').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			arrows: false,
			dots: true,
			adaptiveHeight: true
		});


	}

	$(document).on('click', '.j-mobile-menu-toggle', function (e) {

		e.preventDefault();
		header.toggleClass('menu-active');
		body_lock_toggle();

	});

	var audioID = $('.j-audio-preview');

	$(document).on('click', '.j-play-preview', function (e) {

		e.preventDefault();
		$(this).toggleClass('active');
		audioID[0].play();
		audioID.toggleClass('active');


		if (!audioID.hasClass('active')) {

			console.log('paused main audio');
			audioID[0].pause();

		};

	});

	audioID.on('ended', function () {
		// $('.j-play-preview span').text('Preview audio').parent().removeClass('active');
		audioID.removeClass('active');

	});

	$('.j-p-ls-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		dots: true,
		arrows: false,
		variableWidth: true,
		centerMode: true
	});

	// Alternative preview button ( related cards / PLP )

	var audioIDAlt = $('.j-audio-preview-alt');
	// Delegate clicks on any "▶️ Preview audio" button to this click handler:
	$(document).on('click', '.j-play-preview-alt', function (e) {

		e.preventDefault();

		// Revert any currently active card(s):
		$('.j-toggle-card-state.active').removeClass('active');
		$(this).closest('.j-toggle-card-state').toggleClass('active');

		// Fix WEB-318: Use native dataset instead of $(this).data("mp3") because jQuery may cache data() values:
		var src = this.dataset.mp3;

		$('.j-audio-preview-alt source').attr('src', src);

		audioIDAlt.get(0).load();
		audioIDAlt.get(0).play();
		audioIDAlt.get(0).muted = false;

		if ($(this).hasClass('active')) {

			audioIDAlt.get(0).pause();
			// $(this).find('span').text('Preview audio');

		};

		$(this).toggleClass('active');

		if ($(this).hasClass('active')) {

			$(this).parentsUntil('card-item').siblings().find('.j-play-preview-alt').removeClass('active');

		}

		if ($(this).hasClass('j-player-preview')) {

			$('.j-player-preview').each(function () {

				if ($(this).hasClass('active')) {

					$(this).find('.fas').addClass('active');

				} else {

					$(this).find('.fas').removeClass('active');

				}

			}); $(this).find('.fas').addClass('active').parent().parent().parent().parent().siblings().find('.fas').removeClass('active');

		}

	});

	audioIDAlt.on('ended', function () {
		// $('.j-play-preview-alt span').text('Preview audio');
		$('.j-play-preview-alt, .j-play-preview-alt .fas').removeClass('active');
	});

	// Close card preview if clicked outsisde


	$(document).mouseup(function (e) {

		var card_container = $('.j-toggle-card-state');
		if (!card_container.is(e.target) && card_container.has(e.target).length === 0) {
			card_container.removeClass('active');
			//audioIDAlt.get(0).pause();
			// $('.j-play-preview-alt span').text('Preview audio');
			$('.j-play-preview-alt, .j-play-preview-alt .fas').removeClass('active');
		}
	});


	// Related cards to carousel from 1250px and less

	$('.j-rc-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: true,
		dots: true,
		variableWidth: true,
		centerMode: true,
		responsive: [
			{
				breakpoint: 639,
				settings: {
					variableWidth: true,
					arrows: false
				}
			}
		]
	});

	// Show mobile CTA product buttons on scroll

	// if ($(window).width() < 1024 ) {

	// 	$(window).scroll(function() {
	//         if ($(document).scrollTop() > 40) {

	//         	$('.j-play-preview, .p-content-wrap .j-ajax-add-cart').css('bottom', '0px');
	//         	console.log('show reached')

	//         } else {

	//         	$('.j-play-preview, .p-content-wrap .j-ajax-add-cart').css('bottom', '-70px');
	//         	console.log('hide reached')

	//         }

	//     });

	// }

	// Initialize bundle images on product page

	$('.j-bundle-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: true,
		fade: true,
		speed: 100
	});

	// Card animation

	function next_prev_cards_bundle() {

		$('.slick-slide').removeClass('prevCard nextCard');
		var current = $('.j-bundle-carousel').find('.slick-current');
		current.prev().addClass('prevCard');
		current.next().addClass('nextCard');

	}

	next_prev_cards_bundle();

	$('.j-bundle-carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
		next_prev_cards_bundle();
	});

	// Scroll to how to section on 'create your own' cards product page

	$(document).on('click', '.j-scroll-howto', function (e) {

		e.preventDefault();

		$('html,body').animate({
			scrollTop: $('.product-type-blocks').offset().top
		});

	});

	// Variation change

	$('.j-p-type-blocks-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: true
	});

	if ($('.product-type-blocks .slick-dots li').length < 2) {

		$('.product-type-blocks .slick-dots').hide();

	}

	// Featrured collection carousel

	$('.j-collection-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: false,
		dots: true,
		variableWidth: true,
		centerMode: true,
		focusOnSelect: true,
		autoplaySpeed: 4000
	});

	// Kill link unless active - library collection carousel

	$(document).on('click', '.j-collection-carousel .item', function (e) {

		e.preventDefault();

		$('.j-collection-carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {

			console.log(currentSlide);
			$('.j-collection-carousel .item').each(function () {

				if ($(this).data('slick-index') == currentSlide) {

					$(this).addClass('allow-href');

				} else {

					$(this).removeClass('allow-href');

				}

			});


		});

		if ($(this).hasClass('allow-href')) {

			window.location = this.href;

		}

	});

	// On variant change ( CYO cards )

	$(document).on('click', '.j-variant-change', function () {

		console.log('variant changed');
		var variantID = $(this).data('variant');
		console.log(variantID);
		$('.j-ajax-add-cart').val(variantID);

		var variantPrice = $(this).data('price');
		console.log(variantPrice);
		$('.j-v-price').text(variantPrice);
		$('.add-to-basket').text(variantPrice);

		$(this).parent().addClass('active').siblings().removeClass('active');

	});

	$(document).on('click', '.j-filter-toggle', function (e) {

		e.preventDefault();
		$(this).parent().toggleClass('active');
		//$('.filter-list.expand-authors').removeClass('expanded');

	});

	$(document).on('click', '.j-expand-authors', function (e) {

		e.preventDefault();
		$('.expanded-li').toggleClass('active');
		$('.expand-authors').toggleClass('active');

	});


	$(document).on('change', '#sort_list', function () {

		var loc = location.href;

		if ($(this).val() == 'price-low-high') {
			window.location.replace(loc + '?sort_by=price-ascending');
		}

		if ($(this).val() == 'price-high-low') {
			window.location.replace(loc + '?sort_by=price-descending');
		}

		if ($(this).val() == 'best-selling') {
			window.location.replace(loc + '?sort_by=best-selling');
		}

	});



	// Style images on article page

	$('.j-article-imgs img').each(function () {

		if ($(this).attr('alt') == 'half') {

			$(this).addClass('img-half');
			$(this).parent().addClass('p-remove');

		}

		if ($(this).attr('alt') == 'full') {

			$(this).addClass('img-full');
			$(this).parent().addClass('p-remove');

		}

	});

	// Close cookie modal

	$(document).on('click', '.j-close-cookie', function (e) {

		e.preventDefault();
		$(this).parent().removeClass('active');
		Cookies.set('cookie_box', 'true', { expires: 365 });

	});

	$(document).on('click', '.j-close-newsletter', function (e) {

		e.preventDefault();
		$(this).parent().removeClass('active');
		Cookies.set('newletter_box', 'true', { expires: 365 });

	});

	// Set cookie for cookie policy modal

	var cookie_box = Cookies.get('cookie_box');
	var newletter_box = Cookies.get('newletter_box');

	if (cookie_box == undefined) {

		console.log('cookie_box undefined');
		setTimeout(function () {
			$('.cookie-modal').addClass('active');
		}, 3000);

	} else if (newletter_box == undefined) {
		console.log('newletter_box undefined');
		setTimeout(function () {
			$('.newsletter-modal').addClass('active');
		}, 3000);
	}

	// CS template mobile nav toggle

	$(document).on('click', '.j-cs-nav-toggle', function (e) {

		e.preventDefault();
		$(this).parent().parent().toggleClass('active');

	});



	// Redirect to product page on card click - mobile only

	if ($(window).width() < 1024) {

		$(document).on('click', '.cp-wrapper .j-toggle-card-state', function (e) {

			e.preventDefault();
			var p_url = $(this).data('purl');
			console.log(p_url);
			window.location.href = 'https://' + p_url;

		});

	}

	// Collection mobile filter toggle

	$(document).on('click', '.j-trigger-c-filters', function (e) {

		e.preventDefault();
		$(this).toggleClass('active');
		$('.collection-sort, .collection-search').removeClass('active');
		$('.c-filters').toggleClass('active');

	});

	$(document).on('click', '.j-trigger-c-sort', function (e) {

		e.preventDefault();
		$(this).toggleClass('active');
		$('.c-filters, .collection-search').removeClass('active');
		$('.collection-sort').toggleClass('active');

	});

	$(document).on('click', '.j-trigger-c-search', function (e) {

		e.preventDefault();
		$(this).toggleClass('active');
		$('.c-filters, .collection-sort').removeClass('active');
		$('.collection-search').toggleClass('active');

	});
	//page
	$(document).on("click", ".j-faq-trigger", function (e) {
		e.preventDefault();

		if ($(this).hasClass("j-cs-faqs")) {
			$(this).toggleClass("active").next().toggleClass("active");
		} else {
			$(this).toggleClass("active").parent().next().toggleClass("active");
		}
	});

	// CS - FAQ trigger

	$(document).on("click", ".j-cs-faq-trigger", function (e) {
		e.preventDefault();

		if ($(this).hasClass("j-cs-faqs-title")) {
			$(this).toggleClass("active");
			$("." + this.dataset.id).toggleClass("active");
		} else if ($(this).hasClass("j-cs-faqs")) {
			$(this).toggleClass("active").next().toggleClass("active");
		}
		else {
			$(this).toggleClass("active").parent().next().toggleClass("active");
		}
	});

	$(document).on("click", ".j-account-menu li a", function (e) {
		if (!$(this).hasClass("j-cs-nav-toggle")) {
			if ($(this).data("acc")) {
				e.preventDefault();
				$(this)
					.addClass("active")
					.parent()
					.siblings()
					.find("a")
					.removeClass("active");
				var toShow = $(this).data("acc");
				var langParam = document.documentElement.getAttribute('lang');
				$(".account-block").removeClass("active");
				$(".account-block." + toShow + "").addClass("active");
				if(langParam === 'fr'){
					window.history.replaceState({}, document.title, "/" +langParam+ "/account/#" + toShow);
				} else{
					window.history.replaceState({}, document.title, "/account/#" + toShow);
				}

				

				if ($(window).width() < 1024) {
					var active_title = $(this).text();
					$(".j-cs-nav-toggle").text(active_title);
					$(".j-account-menu").removeClass("active");
				}
			}
		}
	});

	$(document).on('click', '.j-forgotten-password', function (e) {

		e.preventDefault();
		$('.j-account-login-block').hide();
		$('.j-reset-password-block').show();

	});

	$(document).on('click', '.j-login-block', function (e) {

		e.preventDefault();
		$('.j-reset-password-block').hide();
		$('.j-account-login-block').show();

	});

	function check_account_hash() {

		$('.account-block').removeClass('active');
		$('.account-block.' + acc_data + '').addClass('active');

		$('.j-account-menu li a').each(function () {

			if ($(this).data('acc') == acc_data) {

				$(this).addClass('active').parent().siblings().find('a').removeClass('active');;

			}

		});

	}

	if (document.location.href.indexOf('#order-history') > -1) {
		var acc_data = 'order-history';
		check_account_hash();
		$('.j-cs-nav-toggle').text('Order history');
	}
	if (document.location.href.indexOf('#yoto-tokens') > -1) {
		var acc_data = 'yoto-tokens';
		check_account_hash();
		$('.j-cs-nav-toggle').text('My Yoto Tokens');
	}

	if (document.location.href.indexOf('#account-details') > -1) {
		var acc_data = 'account-details';
		check_account_hash();
		$('.j-cs-nav-toggle').text('Account details');
	}

	// Show address list on account page

	$(document).on('click', '.j-show-address-list', function (e) {

		e.preventDefault();
		$('.address-list').toggleClass('active');
		$('.address-int').matchHeight();

	});

	// Show add new address section on account page

	$(document).on('click', '.j-show-address-add', function (e) {

		e.preventDefault();
		$('.add-address-wrapper').toggleClass('active');

	});
	$(document).on("click", ".j-cancel", function (e) {
		$(".add-address-wrapper").toggleClass("active");
	});

	// Show form to edit address

	$(document).on("click", ".j-show-address-edit-form", function (e) {
		e.preventDefault();

		var addressID = $(this).data("address");

		if ($(".edit-address-form").hasClass("active") && $("#EditAddress_" + addressID).hasClass("active")) {
			$("#EditAddress_" + addressID).removeClass("active");
		} else {
			$(".edit-address-form").removeClass("active");
			$("#EditAddress_" + addressID).addClass("active");
		}

	});

	// Set default address - edit address

	$(document).on('click', '#set_default_new_address', function () {

		if ($('#set_default_new_address input').is(':checked')) {
			$(this).addClass('active');
		} else {
			$(this).removeClass('active');
		}

	});

	$(document).on('click', '.address_default_address_new', function () {

		if ($('.address_default_address_new input').is(':checked')) {
			$(this).addClass('active');
		} else {
			$(this).removeClass('active');
		}

	});



	// Our story page image carousel

	$('.j-os-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: true,
		variableWidth: true,
		centerMode: true
	});

	//accessories carousel
	$(".j-accessories-carousel").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplay: false,
		arrows: false,
		dots: true,
		customPaging: function (slick, index) {
			return '<img src="' + slick.$slides[index].dataset.thumb + '"/>';
		},
		variableWidth: true,
		centerMode: true,
	});


	$(".j-featured-accessories-carousel").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		// autoplay: true,
		autoplay: false,
		arrows: false,
		dots: true,
		variableWidth: true,
		centerMode: true,
	});

	$(".j-promo-carousel").slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		// autoplay: true,
		autoplay: false,
		arrows: false,
		dots: false,
		variableWidth: true,
		centerMode: true,
	});

	// Yoto club page image carousel

	$('.j-yc-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: true,
		fade: true
	});

	// Our story page timeline carousel

	$('.j-os-timeline-carousel').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		arrows: false,
		dots: true
	});

	// Toggle multi product selector / Player and Club pages only

	// $(document).on('click', '.j-change-variant', function(){

	// 	var id = $(this).data('id');
	// 	$(this).addClass('active').siblings().removeClass('active');
	// 	$(this).closest('.product-selection').addClass('REACHED');

	// });

	$(document).on('click', '.j-multi-product-selector.is-club', function () {

		if ($(this).hasClass('has-variant')) {

			if (!$(this).hasClass('active')) {

				$('.j-mp-add-product').addClass('j-choose-psu');

			}

		} else {

			$('.j-mp-add-product').removeClass('j-choose-psu');

		}

		$(this).addClass('active').siblings().removeClass('active');

		var p_id = $(this).data('productid');
		var p_state = $(this).data('p-state');
		$('.j-mp-add-product').val(p_id);

		$('.j-mp-add-product').text(p_state).css('text-transform', 'capitalize');
		$('.j-mp-add-product').removeClass('disabled');

		if ($(this).data('p-state') == 'pre-order') {

		} else if ($(this).data('p-state') == 'unavailable') {
			$('.j-mp-add-product').addClass('disabled');
		} else {
			$('.j-mp-add-product').text('Add to Basket');
		}

		var img_id = $(this).data('img');
		$('.j-mp-img').hide();
		$('.j-mp-img.' + img_id + '').css('display', 'block');

	});

	$('.j-append-href-club a').each(function () {

		var _href = $(this).attr("href");
		$(this).attr("href", _href + '?referrer=club');

	});

	$('.j-append-href-player a').each(function () {

		var _href = $(this).attr("href");
		$(this).attr("href", _href + '?referrer=player');

	});

	// Seasonal cards carousel - Yoto Club page

	if ($(window).width() < 1024) {

		$('.j-seasonal-cards').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			arrows: false,
			dots: true
		});

	}

	// Club page - click to scroll to purchase area

	$(document).on('click', '.j-scroll-to-club, .j-scroll-to-player', function (e) {

		e.preventDefault();
		$('html, body').animate({
			scrollTop: $('.in-page-purchase-options').offset().top - 100
		}, 1000);

	});

	// Player features carousel - Player page

	$('.j-player-features-carousel').slick({
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		arrows: true,
		dots: false,
		draggable: false,
		pauseOnHover: false,
		pauseOnFocus: false,
		swipe: true,
		responsive: [
			{
				breakpoint: 639,
				settings: {
				}
			}
		]
	});

	// Pause slider until reached

	//$('.j-player-features-carousel').slick('slickPause');


	// Set width of first pagination element

	var max_no = $('.j-pf-pagination .item:last-child').data('gotoslide');
	var z_width = 100 / max_no;
	console.log(z_width);
	$('.pf-pagination .p_background').css('width', z_width + '%');

	// Change pagination width on change

	$(document).on('click', '.j-pf-pagination .item', function (e) {

		e.preventDefault();
		var goToSlide = $(this).data('gotoslide');
		var max_no = $('.j-pf-pagination .item:last-child').data('gotoslide');
		var width = 100 / max_no;
		var total_width = goToSlide * width;
		$('.pf-pagination .p_background').css('width', total_width + '%');
		$('.j-player-features-carousel').slick('slickGoTo', goToSlide - 1);

		if ($(window).width() < 639) {

			$(this).addClass('active').siblings().removeClass('active');
			var active_icon = $('.j-pf-pagination .item.active p').text();

		}

	});


	$('.j-player-features-carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {

		var currentslide = $('.j-player-features-carousel .slick-current').data('slick-index');
		var slideto = currentslide + 1;
		console.log(currentslide);
		console.log(slideto);

		$('.j-pf-pagination .item').removeClass('active');

		if ($(window).width() < 639) {
			$('.j-pf-pagination .item[data-gotoslide="' + slideto + '"]').addClass('active');
		} else {
			$('.j-pf-pagination .item[data-gotoslide="' + slideto + '"]').trigger('click');
		}

	});


	// function start_pagination_timer() {

	// 	console.log('Start pagination timer');
	// 	window.setInterval(function(){

	// 		//var current_width = $('.pf-pagination .p_background').width();
	// 		var current_width = $(".pf-pagination .p_background").width() / $('.pf-pagination .p_background').parent().width() * 100;




	// 		console.log(current_width);
	// 		console.log(z_width);

	// 		var total_width = current_width + z_width;

	// 		$('.pf-pagination .p_background').css( 'width', total_width + '%' );


	// 	}, 1000);

	// }

	$(window).scroll(function () {

		if ($('.player-features').visible()) {

			//$('.j-player-features-carousel').slick('slickPlay');
			//console.log('slick play');
			//start_pagination_timer();
			//$(window).off('scroll'); // Error - stops all other scroll events

		}

	});

	$(document).on('click', '.j-toggle-cart', function (e) {

		e.preventDefault();
		$('.cart-popup').addClass('active');
		$('.cart_bg').fadeIn();
		window.scrollTo(0, 1);

	});

	$(document).on('click', '.j-close-cart', function (e) {

		e.preventDefault();
		$('.cart-popup').removeClass('active');
		$('.cart_bg').fadeOut();


	});

	// Run check across all add-to-basket buttons to see if product is in cart









	// CART JS

	// Product / Collection page add to cart function

	$(document).on('click', '.j-ajax-add-cart', function (e) {

		e.preventDefault();

		if (!$(this).hasClass('disabled')) {

			var productID = $(this).val();
			var quantity = 1;

			console.log(productID);

			if (!$(this).hasClass('product-atc')) {

				// $(this).addClass('added');

			}

			CartJS.addItem(productID, quantity, {}, {
				"success": function (data, textStatus, jqXHR) {

					// $('.cart-popup').addClass('active');
					// $('.cart_bg').fadeIn();
					$('.cart').addClass('hasItems');
					console.log('success reached');

					$('.added-to-cart-announcement').addClass('active');
					$(".add-to-basket[value='" + productID + "']").addClass('added').prop('disabled', true);

					setTimeout(function () {
						$('.added-to-cart-announcement').removeClass('active');
					}, 2000);

				},
				"error": function (jqXHR, textStatus, errorThrown) {
					console.log('Error: ' + errorThrown + '!');
				}
			});

		}

	});


	$(document).on("click", ".cart-popup .j-remove", function (e, cart) {
		e.preventDefault();
		var productID = $(this).data("id");
		var productHandle = $(this).data("rhandle");
		var dependentItemID = $(this).data("dependent_itemid");
		if (dependentItemID) {

			if (dependentItemID.length > 14) {
				dependentItemID = (dependentItemID.match(/.{1,14}/g));
				for (i = 0; i < dependentItemID.length; i++) {
					CartJS.removeItemById(dependentItemID[i]);
					$('[data-id="' + dependentItemID[i] + '"]').fadeOut();

				}
			} else {
				CartJS.removeItemById(dependentItemID);
				$('[data-depends_on_itemid="' + productID + '"]').fadeOut();
				$('[data-id="' + dependentItemID + '"]').fadeOut();
			}
		}
		CartJS.removeItemById(productID);
		$(this).closest(".cart_item").fadeOut();
		// $(".j-cart-status[data-pid=" + productHandle + "]")
		// 	.removeClass("added")
		// 	.prop("disabled", false);
		$('.j-cart-status[value=' + productID + ']').removeClass('added').prop("disabled", false);
	});


	$(document).on('click', '.cart_contents .quantity_selector span', function () {

		var itemID = $(this).parent().find('input').data('id');
		console.log(itemID);

		if ($(this).hasClass('minus')) {

			if ($(this).parent().find('.j-quantity-update').val() < 2) {
				console.log('smaller than 0');
				$('.update_container').addClass('show');
			} else {

				var counter = parseInt($(this).parent().find('.j-quantity-update').val());
				counter--;
				CartJS.updateItemById(itemID, counter);
				$(this).parent().find('.j-quantity-update').attr('value', counter);

			}

		}

		if ($(this).hasClass('plus')) {

			var counter = parseInt($(this).parent().find('.j-quantity-update').val());
			counter++;
			CartJS.updateItemById(itemID, counter);
			$(this).parent().find('.j-quantity-update').attr('value', counter);

		}

	});


	$(document).on('cart.requestComplete', function (event, cart) {
		cartRequestComplete();
	});

	// Upsell functionsality on load

	$(".j-cart-item").each(function () {

		if ($(this).hasClass("j-show-upsell") && $(".j-cart-item").length < 2) {
			$(".cart_contents_wrapper").addClass("has-psu");
			if ($(this).hasClass("multi-item")) {

				$(".j-checkout").addClass("j-cart-warning");
			} else {
				$(".cart-upsell").show();
				$(".j-checkout").addClass("j-enable-psu-alert");
			}
		} else if ($(this).hasClass("multi-item")) {

			$(".j-checkout").addClass("j-cart-warning");
		} else {
			$(this).removeClass("j-cart-warning");
		}
	});

	function cartRequestComplete() {
      	var langParam = document.documentElement.getAttribute('lang');
		if(langParam !== 'fr' || !langParam){
			var newLangParam ='';
		} else {
			var newLangParam ='/'+langParam;
		}

		$('.cart_contents_wrapper').load(newLangParam+'/cart .cart_contents', function () {

			$('.j-toggle-cart').text();
			$('.h-controls .cart').addClass('animated tada');

			setTimeout(function () {
				$('.h-controls .cart').removeClass('animated tada');
			}, 1000);

			jQuery.getJSON(window.root_url + '/cart.js', function (cart) {
				$('.j-toggle-cart').text(cart.item_count);
			});

		});

		setTimeout(function () {
			$(".j-cart-item").each(function () {
				if ($(this).hasClass("j-show-upsell") && $(".j-cart-item").length < 2) {
					$(".cart_contents_wrapper").addClass("has-psu");
					if ($(this).hasClass("multi-item")) {

						$(".j-checkout").addClass("j-cart-warning");
					} else {
						$(".cart-upsell").show();
						$(".j-checkout").addClass("j-enable-psu-alert");
					}
				} else if ($(this).hasClass("multi-item")) {

					$(".j-checkout").addClass("j-cart-warning");
				} else {
					$(this).removeClass("j-cart-warning");
				}
			});
		}, 1000);

	}

	// Open cart is URL contains ?cart

	if (document.location.href.indexOf('?cart=true') > -1) {
		$('.cart-popup').addClass('active');
		$('.cart_bg').fadeIn();
		console.log('reload cart to clear cache');
		cartRequestComplete();
	}

	if ($(window).width() > 639) {

		// Referrer == club notification

		if (document.location.href.indexOf('?referrer=club') > -1) {
			setTimeout(function () {
				$('.refered_product, .j-club').addClass('active');
			}, 3000);
		}

		// Referrer == player notification

		if (document.location.href.indexOf('?referrer=player') > -1) {
			setTimeout(function () {
				$('.refered_product, .j-player').addClass('active');
			}, 3000);
		}

	}

	$(document).on('click', '.j-kill', function (e) {

		e.preventDefault();

	});

	$(document).on('click', '.j-close', function (e) {

		e.preventDefault();
		$('.refered_product, .refered_product .item').removeClass('active');

	});

	$(document).on('click', 'a[data-vimeoid]', function (e) {

		e.preventDefault();
		var vimeo_id = $(this).data('vimeoid');
		console.log(vimeo_id);
		$('.vimeo-lb .vimeo_insert').append('<iframe src="https://player.vimeo.com/video/' + vimeo_id + '?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>');
		$('.vimeo-lb').fadeIn();
		var iframe = document.querySelector('.vimeo_insert iframe');
		var player = new Vimeo.Player(iframe);
		player.play();

	});

	$(document).on('click', '.j-close-vimeo-lb', function (e) {

		e.preventDefault();
		$('.vimeo-lb').fadeOut();
		var iframe = document.querySelector('.vimeo_insert iframe');
		var player = new Vimeo.Player(iframe);
		player.pause();
		$('.vimeo-lb .vimeo_insert iframe').remove();

	});


	if ($(window).width() < 639) {

		const tilt = $('.template-product .product-template .flex-wrapper .card-img .img-wrap img').tilt();
		tilt.tilt.destroy.call(tilt);

	}

	$('.slick-slider').each(function () {

		if ($(this).find('.slick-dots li').length < 2) {

			$(this).find('.slick-dots').hide();

		}

	});



	$(document).on('click', '.j-toggle-description', function (e) {

		e.preventDefault();
		$(this).fadeOut();
		$('.content-of').addClass('active');
		$(".content-ofaccessories").addClass("active");

	});

	// Upsell on cart JS

	$(document).on('click', '.j-psu-change', function () {

		console.log('PSU variant changed');
		var v_id = $(this).data('variant');
		var v_img = $(this).data('variant-img');
		var v_price = $(this).data('price');


		console.log(v_id);
		console.log(v_img);
		console.log(v_price);

		$('.j-add-psu').data('vid', v_id);
		$('.j-psu-price').text(v_price);
		$('.j-psu-img').attr('src', v_img);


	});

	$(document).on('click', '.j-add-psu', function (e) {

		e.preventDefault();
		var variant_id = $(this).data('vid');
		console.log(variant_id);

		CartJS.addItem(variant_id, 1, {}, {
			"success": function (data, textStatus, jqXHR) {
			},
			"error": function (jqXHR, textStatus, errorThrown) {
				console.log('Error: ' + errorThrown + '!');
			}
		});

	});

	// USP Carousel

	if ($(window).width() < 640) {

		$('.j-usp-carousel').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			arrows: false,
			dots: true,
			swipeToSlide: true
		});

	}


	$('.j-player-page-library').slick({
		infinite: true,
		autoplay: true,
		arrows: true,
		dots: false,
		variableWidth: true,
		centerMode: true,
		swipeToSlide: true,
		lazyLoad: 'ondemand',
		responsive: [
			{
				breakpoint: 639,
				settings: {
					arrows: false
				}
			}
		]
	});

	// PSU upsell lightbox

	$(document).on('click', '.j-upsell-info', function (e) {

		e.preventDefault();
		$('.info-popup').fadeIn();

	});

	$(document).on('click', '.j-close-info', function (e) {

		e.preventDefault();
		$('.info-popup').fadeOut();

	});

	$(document).on('click', '.j-checkout', function (e) {

		if ($(this).hasClass('j-enable-psu-alert')) {

			e.preventDefault();
			//alert('click prevented');
			$('.cart-upsell').addClass('alert-active');

			$(this).removeClass('j-enable-psu-alert');
			$(this).html('Continue <i class="fas fa-arrow-right"></i>');
			$('.cart-upsell').addClass('animated pulse');

		}

	});

	// Country dropdown selector

	$(document).on('click', '.j-cselector', function (e) {

		e.preventDefault();
		$(this).next('div').slideToggle().parent().toggleClass('active');

	});

	// Initialise selectric

	$('select.selectric').selectric();

	$(document).on('click', '.j-show-filters', function (e) {

		e.preventDefault();
		$('.filter-group').slideDown();
		$('.j-filter-ol').fadeIn();
		$('body').addClass('lock');

	});

	$(document).on('click', '.j-close-filter-controls', function (e) {

		e.preventDefault();
		$('.filter-group').slideUp();
		$('.j-filter-ol').fadeOut();
		$('body').removeClass('lock');

		$('html, body').animate({
			scrollTop: $('.collection-wrapper').offset().top - 100
		}, 1000);

	});


	// Adjust library filters on tablet and mobile

	// if ($(window).width() < 1024) {

	// 	var innerHeight = window.innerHeight;
	// 	var filter_max_height = innerHeight - 140;
	// 	$('.collection-wrapper .filter-group').css('max-height', filter_max_height);

	// 	$(window).scroll(function() {

	// 		var innerHeight = window.innerHeight;
	// 		var filter_max_height = innerHeight - 140;
	// 		$('.collection-wrapper .filter-group').css('max-height', filter_max_height);

	// 	});

	// 	$(document).on('click', '#collection-search input', function(){

	// 		setTimeout(function(){

	// 			var innerHeight = window.innerHeight;
	// 			var filter_max_height = innerHeight - 140;
	// 			$('.collection-wrapper .filter-group').css('max-height', filter_max_height);

	// 		}, 500);

	// 	});

	// }

	// Scroll to club

	$(document).on('click', '.j-scroll-to-club-purchase', function (e) {

		e.preventDefault();


		$('html,body').animate({
			scrollTop: $('#shopify-section-club-recharge-product').offset().top - 150
		}, 1000);

	});

});